import React, { useEffect, useState } from "react";
import styled from "styled-components";
// import { CSVLink } from "react-csv";
import { getLocale } from "react-i18nify";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

import * as MatStyled from "@mui/material/styles";
import { Typography } from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";

// import FileUploadIcon from "@mui/icons-material/FileUpload";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

import Button from "src/components/core/Button";
import TextField from "src/components/core/TextField";

import { getOrderListBySeller } from "src/api/sellerOrder";

import device from "src/styles/device";
import { statusTextColor } from "src/common/color";
import { Green, White } from "src/styles/color";
import useDeviceSize from "src/hooks/useDeviceSize";
import { IconLine } from "src/icons";
import { v4 as uuidv4 } from "uuid";
import { useAuth } from "src/hooks/useAuth";

// const WrapperButton = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   padding: 0px;
//   width: 200px;
//   margin-left: auto;

//   .Button-Add {
//     color: #ffffff;
//     width: 100%;
//     background: #e04132;
//     box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
//       0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
//     border-radius: 16px;
//     height: 52px;
//     padding: 0 16px;
//   }
//   .Button-Add:focus {
//     background-color: #e04132;
//   }
//   .Button-Add:hover {
//     background-color: #e04132;
//     opacity: 0.9;
//   }

//   @media ${device.mobileL} {
//     display: none;
//   }
// `;

const DivMuiContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;

  @media ${device.tabletL} {
    padding: 0;
    border-radius: 0;
    box-shadow: none;
  }
`;

const DivMuiInside = styled.div`
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  /* align-items: center; */
  gap: 24px;

  @media ${device.tabletL} {
    gap: 16px;
    margin-bottom: 12px;
  }
`;

const WrapperText = styled.div`
  // margin-bottom: 32px;
  width: 50%;
  position: relative;
  display: flex;
  justify-content: center;

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
  .MuiTextField-root {
    margin: 8px 0;
  }

  @media ${device.tabletL} {
    width: 85%;
    /* margin-right: 4px; */
  }
  /* @media ${device.mobileL} {
    width: 85%;
  } */
`;

const WrapperStatus = styled.div`
  width: 25%;
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 8px;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }

  @media ${device.tabletL} {
    display: none;
  }
`;

const WrapperIcon = styled.div`
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  display: none;
  padding: 0px;
  width: max-content;
  max-width: 5%;
  margin: 0 auto;

  @media ${device.tabletL} {
    /* width: 5%; */
    display: flex;
    align-items: center;
    max-width: 32px;
  }
`;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }
`;

const ImageNoData = styled.div`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const ImageNotFound = styled.div`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

const WrapperStatusRefund = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 8px;
`;

const ButtonLineDeal = styled(Button)`
  width: 100%;
  height: 48px;
  cursor: pointer;
  border-radius: 24px;
  right: 0;
  font-weight: 500;
  font-size: 1rem;
  line-height: 24px;
  transition: 0.3s;
  /* display: flex;
  align-items: center;
  justify-content: center; */
  padding: 0 24px;
  /* text-decoration: underline; */

  &.MuiButton-root.MuiButton-outlined {
    border: 1px solid #5ac363;
    background: ${White};
    color: ${Green};

    &:hover {
      color: ${Green};
      background: ${White};
    }
  }

  :hover {
    opacity: 0.9;
  }

  @media ${device.mobileL} {
    &.MuiButton-root {
      padding: 8px 16px;
    }
  }
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
  [theme.breakpoints.down("sm")]: {
    marginTop: "64px",
    height: "calc(100vh - 64px)",
  },
}));

const DrawerHeader = MatStyled.styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  height: "75px",
}));

function SellerOrderList({ open }) {
  const { user } = useAuth();

  const navigate = useNavigate();
  const [deviceWidth] = useDeviceSize();

  const [quotationListData, setQuotationListData] = useState([]);
  // const [formatDataCsv, setFormatDataCsv] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [dataSearch, setDataSearch] = useState({
    keyword: null,
    page: 0,
    page_size: 10,
    status: "",
  });
  const [rowCount, setRowCount] = useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const openFilter = Boolean(anchorEl);
  const handleClickFilter = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseFilter = () => {
    setAnchorEl(null);
  };

  const DesktopColumns = [
    {
      field: "createdAt",
      headerName: "Date",
      flex: 2,
      editable: false,
      sortable: false,
      headerAlign: "left",
      align: "left",
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {params?.row?.createdAt
              ? dayjs(params?.row?.createdAt).format("DD-MM-YYYY")
              : "-"}
          </div>
        );
      },
    },
    {
      field: "runningNumber",
      headerName: getLocale() === "th" ? "เลข order" : "Order Number",
      flex: 2,
      editable: false,
      sortable: false,
      headerAlign: "left",
      align: "left",
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div className="rowitem">{params?.row?.running_number}</div>;
      },
    },
    {
      field: "status",
      headerName: getLocale() === "th" ? "สถานะ" : "Status",
      flex: 2,
      editable: false,
      sortable: false,
      headerAlign: "center",
      align: "center",
      flexDirection: "column",
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              margin: "8px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              outline: "none",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                textAlign: "center",
                ...statusTextColor(params),
              }}
              disableRipple
            >
              {getLocale() === "th"
                ? params.row.status_th
                : params.row.status_en}
            </Typography>

            {params.row.status_refund === "refund" ? (
              <WrapperStatusRefund>
                <span
                  style={{
                    color: "#E13B30",
                    fontSize: "0.75rem",
                    fontWeight: 500,
                  }}
                >
                  ออเดอร์มีการคืนเงิน
                </span>
              </WrapperStatusRefund>
            ) : null}

            {params.row.status_refund === "wait refund" ? (
              <WrapperStatusRefund>
                <ErrorIcon
                  sx={{
                    color: "#E13B30",
                  }}
                />

                <span
                  style={{
                    color: "#E13B30",
                    fontSize: "0.75rem",
                    fontWeight: 500,
                  }}
                >
                  ออเดอร์รอการคืนเงิน
                </span>
              </WrapperStatusRefund>
            ) : null}

            {params.row.status_refund === "succ refund" ? (
              <WrapperStatusRefund>
                <CheckCircleIcon
                  sx={{
                    color: "#3CB11E",
                  }}
                />

                <span
                  style={{
                    color: "#6A665A",
                    fontSize: "0.75rem",
                    fontWeight: 500,
                  }}
                >
                  ออเดอร์คืนเงินสำเร็จ
                </span>
              </WrapperStatusRefund>
            ) : null}
          </Box>
        );
      },
    },
    {
      field: "actions",
      headerName: "Action",
      type: "actions",
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Detail"
          onClick={() =>
            window.open(`/seller-order/detail/${params.row._id}`, "_blank")
          }
          showInMenu
        />,
      ],
    },
  ];

  const MobileColumns = [
    {
      field: "runningNumber",
      headerName: getLocale() === "th" ? "เลข order" : "Order Number",
      flex: 2,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div className="rowitem">{params?.row?.running_number}</div>;
      },
    },
    {
      field: "status",
      headerName: getLocale() === "th" ? "สถานะ" : "Status",
      flex: 2,
      // width: 200,
      editable: false,
      sortable: false,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
              textAlign: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={statusTextColor(params)}
              disableRipple
            >
              {getLocale() === "th"
                ? params.row.status_th
                : params.row.status_en}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Detail"
          onClick={() => navigate(`/seller-order/detail/${params.row._id}`)}
          showInMenu
        />,
      ],
    },
  ];

  function NoRowsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData />
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  }

  function NoResultsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNotFound />
        <TextNoData>Not Found</TextNoData>
      </Stack>
    );
  }

  const handelActivateLine = () => {
    const params = `response_type=code&client_id=${
      process.env.REACT_APP_CLIENT_LINE_ID_SERVICE
    }&redirect_uri=${
      window.location.origin
    }/line&bot_prompt=aggressive&prompt=consent&scope=profile%20openid&state=${uuidv4()}`;
    window.location.href = `https://access.line.me/oauth2/v2.1/authorize?${params}`;
  };

  const onSearchButton = () => {
    setDataSearch({ ...dataSearch, page: 0 });
    setIsLoading(true);
    (async () => {
      if (user.role_id === 3) {
        const { data } = await getOrderListBySeller({
          ...dataSearch,
          page: 0,
        });
        setQuotationListData(data.data);
        setRowCount(data.count);
        setIsLoading(false);
      }
    })();
  };

  const handlePageChange = (newPage) => {
    // We have the cursor, we can allow the page transition.
    setDataSearch({ ...dataSearch, page: newPage });
  };

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        if (user.role_id === 3) {
          const { data } = await getOrderListBySeller(dataSearch);
          setQuotationListData(
            data.data.map((row) => ({
              ...row,
              status_refund: row?.status_refund ?? "none",
            })),
          );
          setRowCount(data.count);
        }
      } catch (err) {
        console.error("err", err);
      } finally {
        setIsLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.page, dataSearch.status]);

  // useEffect(() => {
  //   const format = [];

  //   function formatProductOrder(order_values) {
  //     let header_order_choices = {};
  //     for (let order_value in order_values) {
  //       if (
  //         ![
  //           "_id",
  //           "product_choice_order",
  //           "group_price",
  //           "color",
  //           "texture_type",
  //           "size",
  //           "install_detail_group",
  //         ].includes(order_value)
  //       )
  //         header_order_choices[`product_choice_orders_${order_value}`] =
  //           order_values[order_value];
  //     }

  //     for (let product in order_values.product_choice_order.product) {
  //       if (["item_code", "item_name"].includes(product)) {
  //         header_order_choices[`product_choice_orders_${product}`] =
  //           order_values.product_choice_order.product[product];
  //       }
  //     }

  //     for (let order_value in order_values.color) {
  //       if (["color_th", "color_en"].includes(order_value))
  //         header_order_choices[`product_choice_orders_${order_value}`] =
  //           order_values.color[order_value];
  //     }

  //     for (let order_value in order_values.texture_type) {
  //       if (["type_th", "type_en"].includes(order_value))
  //         header_order_choices[`product_choice_orders_${order_value}`] =
  //           order_values.texture_type[order_value];
  //     }

  //     for (let order_value in order_values.install_detail_group) {
  //       header_order_choices[
  //         `product_choice_orders_install_detail_group_${order_value}`
  //       ] = order_values.install_detail_group[order_value];
  //     }

  //     for (let order_value in order_values.size) {
  //       if (order_value === "quantity") {
  //         header_order_choices[`product_choice_orders_${order_value}`] =
  //           order_values.size[order_value];
  //       }
  //     }
  //     if (order_values.size?.quantity === "size")
  //       header_order_choices[
  //         `product_choice_order_all_size`
  //       ] = `H ${order_values.size.height} ${order_values.size.unit_height.unit_en} X W ${order_values.size.width} ${order_values.size.unit_width.unit_en} X D ${order_values.size.thickness} ${order_values.size.unit_thickness.unit_en}`;
  //     if (order_values.size?.quantity === "capacity")
  //       header_order_choices[
  //         `product_choice_order_all_size`
  //       ] = `Capacity ${order_values.size.capacity_size} ${order_values.size.unit_capacity.unit_en}`;

  //     // console.log(header_order_choices)
  //     return header_order_choices;
  //   }

  //   function formatData() {
  //     if (quotationListData.length > 0) {
  //       quotationListData.forEach((el) => {
  //         let group_header;
  //         const {
  //           last_update_order,
  //           tax_invoice_address,
  //           status_payment,
  //           product_choice_orders,
  //           user,
  //           discount,
  //           __v,
  //           _id,
  //           ...rest
  //         } = el;
  //         let new_name_tax = {};
  //         for (let key in tax_invoice_address) {
  //           new_name_tax = {
  //             ...new_name_tax,
  //             [`tax_invoice_address_${key}`]:
  //               key === "shipping_address"
  //                 ? Object.values(tax_invoice_address[key])
  //                     .filter((ell) => ell !== "")
  //                     .join(" ")
  //                 : key === "tax_id" || key === "tel"
  //                 ? `${key}=${tax_invoice_address[key]}`
  //                 : tax_invoice_address[key],
  //           };
  //         }

  //         let new_last_update;
  //         for (let key in last_update_order) {
  //           new_last_update = {
  //             ...new_last_update,
  //             [`last_update_order_${key}`]:
  //               key === "admin"
  //                 ? `${last_update_order[key].first_name} ${last_update_order[key].last_name}`
  //                 : last_update_order[key],
  //           };
  //         }

  //         let new_discount;
  //         for (let key in discount) {
  //           new_discount = {
  //             ...new_discount,
  //             [`discount_${key}`]: discount[key],
  //           };
  //         }
  //         // const shipping_address = !!el?.shipping_address
  //         //   ? Object.values(el?.shipping_address)
  //         //       .filter((ell) => ell !== "")
  //         //       .join(" ")
  //         //   : "";

  //         if (el.product_choice_orders.length > 1) {
  //           el.product_choice_orders.forEach((ell, index) => {
  //             const new_header_orders = formatProductOrder(ell);
  //             if (index !== 0) {
  //               group_header = {
  //                 ...new_header_orders,
  //               };
  //               format.push(group_header);
  //             } else {
  //               group_header = {
  //                 ...rest,
  //                 ...status_payment,
  //                 ...new_name_tax,
  //                 ...new_header_orders,
  //                 ...new_last_update,
  //                 ...new_discount,
  //                 // shipping_address,
  //               };
  //               format.push(group_header);
  //             }
  //           });
  //         } else {
  //           const new_header_orders = formatProductOrder(
  //             el.product_choice_orders[0]
  //           );
  //           group_header = {
  //             ...rest,
  //             ...status_payment,
  //             ...new_name_tax,
  //             ...new_last_update,
  //             ...new_header_orders,
  //             ...new_discount,
  //             // shipping_address,
  //           };

  //           format.push(group_header);
  //         }
  //       });
  //     }
  //   }
  //   formatData();
  //   setFormatDataCsv(format);
  // }, [quotationListData]);

  return (
    <>
      <Main open={open}>
        <DrawerHeader />
        <DivMuiContainer>
          <DivMuiInside>
            <WrapperText>
              <TextField
                id="search-input"
                placeholder={
                  getLocale() === "th"
                    ? `ค้นจากเลขออเดอร์`
                    : `search by running number`
                }
                className="TextField-without-border-radius"
                sx={{
                  m: 1,
                  width: "100%",
                  borderRadius: "16px",
                }}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      id="button-search-quotation"
                      sx={{ padding: 0 }}
                      onClick={() => {
                        onSearchButton();
                      }}
                    >
                      <SearchIcon
                        sx={{
                          color: "#e04132",
                          cursor: "pointer",
                        }}
                      />
                    </IconButton>
                  ),
                }}
                onChange={(e) => {
                  setDataSearch({
                    ...dataSearch,
                    keyword: e.target.value,
                  });
                }}
                onKeyUp={(e) => (e.code === "Enter" ? onSearchButton() : null)}
              />
            </WrapperText>

            <WrapperStatus>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  className="TextField-without-border-radius"
                  id="search-input"
                  label="Status"
                  onChange={(e) => {
                    setDataSearch({
                      ...dataSearch,
                      status: e.target.value,
                      page: 0,
                    });
                  }}
                  value={dataSearch.status}
                >
                  {/* TODO: idk about value */}
                  <MenuItem value={""}>
                    {getLocale() === "th" ? `ทั้งหมด` : `All`}
                  </MenuItem>
                  <MenuItem value={"ordered"}>
                    {getLocale() === "th" ? `จ่ายเงินสำเร็จ` : `ordered`}
                  </MenuItem>
                  <MenuItem value={"in progress"}>
                    {getLocale() === "th" ? `กำลังดำเนินการ` : `in progress`}
                  </MenuItem>
                  <MenuItem value={"delivery"}>
                    {getLocale() === "th" ? `ส่งของ` : `delivery`}
                  </MenuItem>
                  <MenuItem value={"wc"}>
                    {getLocale() === "th"
                      ? `รอการยืนยัน`
                      : `waiting for confirm`}
                  </MenuItem>
                  <MenuItem value={"cancel"}>
                    {getLocale() === "th" ? `ยกเลิก` : `cancel`}
                  </MenuItem>
                  <MenuItem value={"success"}>
                    {getLocale() === "th" ? `สำเร็จ` : `success`}
                  </MenuItem>
                </Select>
              </FormControl>
            </WrapperStatus>

            <WrapperIcon>
              <IconButton
                id="filter-button"
                aria-label="filter"
                aria-controls={openFilter ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openFilter ? "true" : undefined}
                sx={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "var(--darkwhite-color)",
                  color: "var(--secondary-color)",
                }}
                onClick={handleClickFilter}
              >
                <FilterAltIcon sx={{ fontSize: 16 }} />
              </IconButton>
              <Menu
                id="filter-menu"
                anchorEl={anchorEl}
                open={openFilter}
                onClose={handleCloseFilter}
                MenuListProps={{
                  "aria-labelledby": "filter-button",
                }}
                sx={{
                  mt: 2,
                  ".MuiMenu-paper": {
                    borderRadius: 6,
                  },
                  ".MuiMenu-list": {
                    p: 0,
                  },
                  ".MuiMenuItem-root": {
                    px: 3,
                    py: 1,
                    ":first-child": {
                      pt: 2,
                    },
                    ":last-child": {
                      pb: 2,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "center", vertical: "top" }}
                anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => {
                    setDataSearch({
                      ...dataSearch,
                      status: "",
                      page: 0,
                    });
                  }}
                >
                  {getLocale() === "th" ? `ทั้งหมด` : `All`}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setDataSearch({
                      ...dataSearch,
                      status: "in progress",
                      page: 0,
                    });
                  }}
                >
                  {getLocale() === "th" ? `กำลังดำเนินการ` : `in progress`}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setDataSearch({
                      ...dataSearch,
                      status: "delivery",
                      page: 0,
                    });
                  }}
                >
                  {getLocale() === "th" ? `ส่งของ` : `delivery`}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setDataSearch({
                      ...dataSearch,
                      status: "wc",
                      page: 0,
                    });
                  }}
                >
                  {getLocale() === "th" ? `รอการยืนยัน` : `waiting for confirm`}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setDataSearch({
                      ...dataSearch,
                      status: "cancel",
                      page: 0,
                    });
                  }}
                >
                  {getLocale() === "th" ? `ยกเลิก` : `cancel`}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setDataSearch({
                      ...dataSearch,
                      status: "success",
                      page: 0,
                    });
                  }}
                >
                  {getLocale() === "th" ? `สำเร็จ` : `success`}
                </MenuItem>
              </Menu>
            </WrapperIcon>

            {/* <WrapperButton>
              <Button
                variant="contained"
                className="Button-Add"
                startIcon={<FileUploadIcon />}
                onClick={() => {
                  if (quotationListData.length < 1) {
                    return;
                  }
                }}
              >
                <CSVLink
                  style={{
                    display: "flex",
                    fontWeight: "500",
                    fontSize: "15px",
                    alignItems: "center",
                    color: "#ffffff",
                    background: "e04132",
                    fontStyle: "normal",
                  }}
                  // data={data}
                  data={formatDataCsv}
                  // data={"mock mock mock"}
                  filename={`order-list-${dayjs(new Date()).format(
                    "DD-MM-YYYY"
                  )}.csv`}
                  // headers={headers}
                  onClick={(event, done) => {
                    if (quotationListData?.length === 0) {
                      return false;
                    }
                  }}
                >
                  Export To CSV
                </CSVLink>
              </Button>
            </WrapperButton> */}
          </DivMuiInside>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              mb: {
                xs: 2,
                md: 3,
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  mr: 2,
                }}
                component="span"
              >
                ทั้งหมด :{" "}
                <Typography
                  component="span"
                  sx={{
                    color: "#E13B30",
                  }}
                >
                  {rowCount}
                </Typography>
              </Typography>
            </Box>

            <Box>
              <ButtonLineDeal
                onClick={() => {
                  handelActivateLine();
                }}
                startIcon={<IconLine fill="#5ac363" className="icon-line" />}
                variant="outlined"
              >
                ติดตามสถานะการขนส่ง
              </ButtonLineDeal>
            </Box>
          </Stack>

          <WrapperDataGrid>
            <DataGrid
              rows={quotationListData}
              getRowId={(row) => row._id}
              getRowHeight={() => "auto"}
              loading={isLoading}
              columns={deviceWidth > 835 ? DesktopColumns : MobileColumns}
              pageSize={10}
              rowCount={rowCount}
              paginationMode="server"
              page={dataSearch.page}
              onPageChange={(e) => handlePageChange(e)}
              rowsPerPageOptions={[10]}
              pagination
              disableSelectionOnClick
              components={{
                NoRowsOverlay,
                NoResultsOverlay,
              }}
              componentsProps={{
                basePopper: {},
              }}
              sx={{
                "& .MuiDataGrid-actionsCell": {
                  transform: "rotate(90deg)",
                },
                "& .MuiDataGrid-row": {
                  minHeight: "50px !important",
                  // padding: '10px 0'
                },
              }}
            />
          </WrapperDataGrid>
        </DivMuiContainer>
      </Main>
    </>
  );
}

export default SellerOrderList;
